export default class Map {
	constructor(el) {
		this.el = el;

		const config = JSON.parse(this.el.dataset.hwcMap);

		this.leafletConfig = {
			lat: config.lat,
			lng: config.lng,
			center: [config.lat, config.lng],
			zoom: 14,
			icon: {
				url: config.icon,
				width: 32,
				height: 32,
			},
		};

    this.initMap();
    this.initMarker();
	}

	initMap() {

		this.map = L.map(this.el, {
			tap: false,
			gestureHandling: true,
		}).setView(this.leafletConfig.center, this.leafletConfig.zoom);

		L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
			attribution:
				'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
		}).addTo(this.map);
 
	}

  initMarker(){

    const marker = new L.Icon({
			iconUrl: this.leafletConfig.icon.url,
			iconSize: [this.leafletConfig.icon.width, this.leafletConfig.icon.height],
			iconAnchor: [this.leafletConfig.icon.width / 2, this.leafletConfig.icon.height],
			popupAnchor: [0, this.leafletConfig.icon.height * -1],
		});

		const LeafletMarker = L.marker(
			{ lat: this.leafletConfig.lat, lng: this.leafletConfig.lng },
			{
				icon: marker,
			}
		);

		LeafletMarker.addTo(this.map);
  }
}
